import { customerInterface } from '../../../../../util/interfaces/customer';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { Component, OnInit } from '@angular/core';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { Observable, observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { customAlertInterface } from 'src/app/util/interfaces/customAlert';
import { CmdbAlertService } from './service/cmdbAlertService.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-cmdb-alert',
	templateUrl: './cmdb-alert.component.html',
	styleUrls: ['./cmdb-alert.component.scss'],
})
export class CmdbAlertComponent implements OnInit {
	id: string;
	queryField = new FormControl();
	results$: Observable<any>;

	labels: LabelsInterface = {
		lbl_geral_selecione: 'SELECT',
		lbl_asset_impressora: 'printer',
		lbl_geral_pesquisa: 'search',
		lbl_geral_cliente: 'customer',
		lbl_geral_email_copia: 'Email in copy',
		lbl_geral_moficado: 'let me know when it is modified',
		lbl_geral_tipo_ativo: 'Asset type',
		lbl_geral_limpar_campos: 'Limpar Campos',
		lbl_geral_criar_notificacoes: 'create notification',
		lbl_geral_pesquisar_notificacoes: 'search notification',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_geral_preencha_campo_obrigatorio_notificacao: 'fill in all fields to create a notification',
		lbl_geral_preencha_campo_obrigatorio_notificacao_pesq: 'fill in all fields to search a notification',
		lbl_asset_hardware: 'hardware',
		lbl_asset_software: 'software',
		lbl_asset_novo_host: 'New host',
		lbl_asset_host_renomeado: 'Host rename',
		lbl_asset_inventario_diferente: 'Inventory different from',
		lbl_asset_ultimo_inventario_alterado: 'Not inventoried at',
		lbl_asset_fee: 'Rate',
		lbl_geral_atualizar: 'Update',
		lbl_geral_voltar: 'Back',
		lbl_nova_notificacao: 'New notification',
		lbl_geral_excluir: 'Delete',
		lbl_geral_confirmar: 'Confirm',
		lbl_clique_confirmar_acao: '',
		lbl_removido_com_sucesso: 'Successful deleted',
		lbl_quantidade_dias: 'Quantidade de dias',
		lbl_geral_inclusao: 'Inclusão',
		lbl_invalid_email: '',
		lbl_alerta_cadastrado: '',
		lbl_dia_para_expirar: '',
		lbl_vencimento_do_emprestimo: '',
		lbl_geral_preencha_campo_obrigatorio_notificacao_válido: 'Preencha campo obrigatorio notificacao. E insira um e-mail válido',
		lbl_geral_pesquisa_info: 'Para iniciar a Pesquisa, preencha um ou mais campos e clique em Pesquisar.',
		lbl_asset_micro: 'Workstation',
		lbl_geral_contratos: 'Contracts',
		lbl_asset_servidor: 'Server',
		lbl_geral_tmbp: 'TMBP',
		lbl_consumable: 'Consumable',
		lbl_alertas_personalizados: '',
	};

	constructor(
		private CmdbAlertService: CmdbAlertService,
		private NotificationService: NotificationService,
		private LabelsService: LabelsService,
		private location: Location,
		private Router: Router,
		private route: ActivatedRoute
	) {}

	AlertItems = [
		{ name: this.labels.lbl_asset_hardware, id: 'hardware', isChecked: false },
		{ name: this.labels.lbl_asset_software, id: 'software', isChecked: false },
		{ name: this.labels.lbl_asset_novo_host, id: 'new_host', isChecked: false },
		{ name: this.labels.lbl_asset_fee, id: 'fee', isChecked: false },
		{ name: this.labels.lbl_asset_host_renomeado, id: 'host_rename', isChecked: false },
	];
	AlertItemsWithoutFee = [
		{ name: this.labels.lbl_asset_hardware, id: 'hardware', isChecked: false },
		{ name: this.labels.lbl_asset_software, id: 'software', isChecked: false },
		{ name: this.labels.lbl_asset_novo_host, id: 'new_host', isChecked: false },
		{ name: this.labels.lbl_asset_host_renomeado, id: 'host_rename', isChecked: false },
	];

	AlertItemsLastInv = [{ name: this.labels.lbl_asset_ultimo_inventario_alterado, id: 'last_inv', isChecked: false }];

	AlertItemsInv = [{ name: this.labels.lbl_asset_inventario_diferente, id: 'inv', isChecked: false }];

	AlertItemsConsumable = [{ name: 'Vencimento do Empréstimo', id: 'lending_expires', isChecked: false }];

	AlertItemsContract = [{ name: '__vencimento do contrato', id: 'maintence_contracts_expires', isChecked: false }];

	selectedTab = 'search';
	selectedCustomAlert: customAlertInterface = {
		asset_type: '',
		customer: '',
		email: '',
		fee: '',
		hardware: '',
		host_rename: '',
		id: '',
		last_inv: '',
		last_inv_days: '',
		new_host: '',
		software: '',
		inv: '',
		inv_version: '',
		maintence_contracts_expires: '',
		maintence_contracts_expires_days: '',
		lending_expires: '',
		lending_expires_days: '',
	};

	customerArray: customerInterface[];
	newCiTypesArray: ciTypesInterface[];
	searchCustomAlerts: customAlertInterface[] = [];
	deleteCustomAlerts: customAlertInterface[] = [];

	isLoadingCustomer = true;
	isLoadingAvailableCiTypes = true;
	isLoadingNewCiType = true;
	isLoadingLabels = true;
	isSearchingNotifications = false;
	isLoadingCustomAlert = false;
	isCreatingNotification = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.getCustomerAndCiTypes();
	}
	onSelect(notificationInterface: customAlertInterface): void {
		this.selectedCustomAlert = notificationInterface;
	}

	getCustomerAndCiTypes() {
		/*this.CmdbAlertService.getCustomer().subscribe(customerRes => {
      this.customerArray = customerRes;
      this.isLoadingCustomer = false;
    });*/
		this.CmdbAlertService.getAvailableCiTypes().subscribe((ciTypesRes) => {
			this.newCiTypesArray = ciTypesRes;
			this.isLoadingNewCiType = false;
		});
	}

	clearForm() {
		for (const item of this.AlertItems) {
			item.isChecked = false;
		}
		this.selectedCustomAlert = {
			asset_type: '',
			customer: '',
			email: '',
			fee: '',
			hardware: '',
			host_rename: '',
			id: '',
			last_inv: '',
			last_inv_days: '',
			new_host: '',
			software: '',
			inv: '',
			inv_version: '',
			maintence_contracts_expires: '',
			maintence_contracts_expires_days: '',
			lending_expires: '',
			lending_expires_days: '',
		};
		for (const item of this.AlertItemsLastInv) {
			item.isChecked = false;
		}
		this.selectedCustomAlert = {
			asset_type: '',
			customer: '',
			email: '',
			fee: '',
			hardware: '',
			host_rename: '',
			id: '',
			last_inv: '',
			last_inv_days: '',
			new_host: '',
			software: '',
			inv: '',
			inv_version: '',
			maintence_contracts_expires: '',
			maintence_contracts_expires_days: '',
			lending_expires: '',
			lending_expires_days: '',
		};
		for (const item of this.AlertItemsConsumable) {
			item.isChecked = false;
		}
		this.selectedCustomAlert = {
			asset_type: '',
			customer: '',
			email: '',
			fee: '',
			hardware: '',
			host_rename: '',
			id: '',
			last_inv: '',
			last_inv_days: '',
			new_host: '',
			software: '',
			inv: '',
			inv_version: '',
			maintence_contracts_expires: '',
			maintence_contracts_expires_days: '',
			lending_expires: '',
			lending_expires_days: '',
		};
		for (const item of this.AlertItemsContract) {
			item.isChecked = false;
		}
		this.selectedCustomAlert = {
			asset_type: '',
			customer: '',
			email: '',
			fee: '',
			hardware: '',
			host_rename: '',
			id: '',
			last_inv: '',
			last_inv_days: '',
			new_host: '',
			software: '',
			inv: '',
			inv_version: '',
			maintence_contracts_expires: '',
			maintence_contracts_expires_days: '',
			lending_expires: '',
			lending_expires_days: '',
		};
		this.getCustomerAndCiTypes();
		for (const item of this.AlertItemsInv) {
			item.isChecked = false;
		}
		this.selectedCustomAlert = {
			asset_type: '',
			customer: '',
			email: '',
			fee: '',
			hardware: '',
			host_rename: '',
			id: '',
			last_inv: '',
			last_inv_days: '',
			new_host: '',
			software: '',
			inv: '',
			inv_version: '',
			maintence_contracts_expires: '',
			maintence_contracts_expires_days: '',
			lending_expires: '',
			lending_expires_days: '',
		};
		this.getCustomerAndCiTypes();
	}

	createNotification(): void {
		if (this.isCreatingNotification === true) return;
		let isAlertItemSelected = false;
		for (const item of this.AlertItems ||
			this.AlertItemsLastInv ||
			this.AlertItemsInv ||
			this.AlertItemsConsumable ||
			this.AlertItemsContract) {
			if (item.isChecked) isAlertItemSelected = true;
			break;
		}
		//TODO Regex de email
		if (this.selectedCustomAlert.asset_type != '' && this.selectedCustomAlert.email != '') {
			//Cadastro
			this.isCreatingNotification = true;
			//this.CmdbAlertService.registerCustomAlert(this.selectedCustomAlert, this.AlertItems, this.AlertItemsLastInv, this.AlertItemsInv, this.AlertItemsConsumable, this.AlertItemsContract).subscribe(res => {
			this.CmdbAlertService.registerCustomAlert(this.selectedCustomAlert).subscribe(
				(res) => {
					this.isCreatingNotification = false;
					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
					this.clearForm();
				},
				(error) => {
					if (error.error.Message.includes('invalid email')) {
						this.NotificationService.setNotificationMessage(this.labels.lbl_invalid_email);
						return (this.isCreatingNotification = false);
					}
					if (error.error.Message.includes('custom alert already created for this email')) {
						this.NotificationService.setNotificationMessage(this.labels.lbl_alerta_cadastrado);
						return (this.isCreatingNotification = false);
					}
					this.clearForm();
				}
			);
		} else {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_preencha_campo_obrigatorio_notificacao_válido);
		}
	}

	searchNotification(): void {
		if (this.isSearchingNotifications) return;
		this.searchCustomAlerts = [];
		if (this.selectedCustomAlert.asset_type != '' || this.selectedCustomAlert.email != '') {
			//Pesquisa
			this.isSearchingNotifications = true;
			this.CmdbAlertService.searchCustomAlert(this.selectedCustomAlert.asset_type, this.selectedCustomAlert.email).subscribe(
				(customAlerts) => {
					this.searchCustomAlerts = customAlerts;
					this.clearForm();
					this.isSearchingNotifications = false;
				},
				(error) => {
					this.NotificationService.setNotificationMessage('Nenhum registro encontrado');
					this.isSearchingNotifications = false;
					this.clearForm();
				}
			);
		} else {
			this.NotificationService.setNotificationMessage(this.labels.lbl_geral_pesquisa_info);
		}
	}

	editNotification(id: string): void {
		if (this.isLoadingCustomAlert) return;
		this.isLoadingCustomAlert = true;

		this.CmdbAlertService.getCustomAlert(id).subscribe((customAlert) => {
			this.selectedCustomAlert = customAlert;

			/*
      this.AlertItems.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });

      this.AlertItemsInv.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });

      this.AlertItemsLastInv.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });

      this.AlertItemsWithoutFee.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });

      this.AlertItemsContract.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });

      this.AlertItemsConsumable.forEach(alertItem => {
        Object.keys(this.selectedCustomAlert).forEach(key => {
          if (key === alertItem.id && this.selectedCustomAlert[key] && this.selectedCustomAlert[key] === 1) {
            alertItem.isChecked = true;
          }
        })
      });
*/
			this.selectedTab = 'register';
			this.isLoadingCustomAlert = false;
		});
	}

	updateNotification() {
		if (this.isLoadingCustomAlert) return;
		this.isCreatingNotification = true;
		this.CmdbAlertService.updateCustomAlert(
			this.selectedCustomAlert,
			this.AlertItems,
			this.AlertItemsLastInv,
			this.AlertItemsInv,
			this.AlertItemsConsumable,
			this.AlertItemsContract
		).subscribe(() => {
			this.isCreatingNotification = false;
			this.NotificationService.setNotificationMessage('Atualizado com sucesso.  Pesquise novamente');
		});
	}

	deleteNotification(index: number): void {
		this.CmdbAlertService.deleteCustom(this.searchCustomAlerts[index].id).subscribe((customAlerts) => {});
		this.searchCustomAlerts.splice(index, 1);
		this.NotificationService.setNotificationMessage('Deletado');
	}

	confirmDeactiveClick(event: Event, index: number): void {
		if (this.isSearchingNotifications) return;

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			this.CmdbAlertService.deleteCustom(this.searchCustomAlerts[index].id).subscribe(() => {
				this.searchCustomAlerts.splice(index, 1);
				this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
			});
		} else {
			(<HTMLElement>event.target).classList.add('double-click');
			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 5000);
		}
	}

	confirmButton(elementReference: HTMLElement, index: number): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
		this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
	}
}
